export const Icon = () => {
  console.error(`
Icon component is deprecated in tokeny-ui > 0.4.4

The "Icon" react component has been deprecated. 
Please use the full named embedded svg component e.g IconAddpeople
For usage and examples see https://cdn.tokeny.com/storybook/index.html?path=/docs/components-icon--page
  `);
  return null;
};